import type { FCM_NEWS_AND_GUIDES_VISIBILITY, FcmConfigValueType } from '@change-corgi/fcm/configs';

import { RedirectError } from '#src/shared/error';

type VisibilityMap = FcmConfigValueType<typeof FCM_NEWS_AND_GUIDES_VISIBILITY>;

export type NewsAndGuidesDisableMode = VisibilityMap[string];

// Country codes are matched case-insensitively — the visibility map is keyed by uppercase country code.
export function getNewsAndGuidesDisableMode(visibility: VisibilityMap, countryCode: string): NewsAndGuidesDisableMode {
	return visibility[countryCode.toUpperCase()];
}

export function redirectToPetitionGuidesIfDisabled(mode: NewsAndGuidesDisableMode): void {
	if (!mode) return;

	throw new RedirectError({
		url: '/petition-guides',
		permanent: mode === 'long',
		reason: 'news_and_guides_disabled',
	});
}
